/**
 * "Finish later" snooze, shared with the dismiss button on the "finish setting up" banner. While it
 * is set, the app gate neither redirects to /welcome nor shows the banner, for the rest of the
 * browser session (sessionStorage).
 */
export const ONBOARDING_SNOOZE_KEY = 'rc.onboarding.snoozed';

/** Used only when sessionStorage is blocked, so "Finish later" still holds until the page reloads. */
let snoozedWithoutStorage = false;

export function snoozeOnboardingForSession(): void {
  try {
    window.sessionStorage.setItem(ONBOARDING_SNOOZE_KEY, '1');
  } catch {
    snoozedWithoutStorage = true;
  }
}

export function isOnboardingSnoozed(): boolean {
  if (snoozedWithoutStorage) return true;
  try {
    return window.sessionStorage.getItem(ONBOARDING_SNOOZE_KEY) === '1';
  } catch {
    return false;
  }
}
